export const openSmsLink = (phoneNumber: string | undefined) => {
    // Browsers maintain the intent of an SMS link (e.g. "Cancel" vs "Open in Messages")
    // which means clicking the same link twice doesn't work as expected
    // This handles creating+clicking on an entirely new DOM element on each click

    return () => {
        if (!phoneNumber) return
        const link = document.createElement('a')
        link.id = `sms-link-${crypto.randomUUID()}`
        link.href = `sms:${phoneNumber}`
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
}
